



import { Box,  Stack, Typography } from "@mui/material"; 
import React from "react";
 
import Head from "next/head";
import AppbarIndustry from "../../../../components/AppbarIndustry";
import HeroSection from "../../../../components/HeroSection";
import TitleIndustry from "../../../../components/TitleIndustry";
import HeroEnquiryFormIndustry from "../../../../components/HeroEnquiryFormIndustry";
import FooterIndustry from "../../../../components/FooterIndustry";
import { ourProducts } from "../../../../components/retail/data";
import StickyWhatsappIndustries from "../../../../components/StickyWhatsappIndustries";

function AdvancedCybersecurity() { 
  const products = [
  
    "E-commerce Platforms with Personalization Features",
    

  ];
  const data = {
    image: "/industries/retail/e-commerce1.avif", // Replace with the appropriate image URL
    intro: `Welcome to our Smart Manufacturing Execution Systems (MES), the key to optimizing manufacturing processes, improving efficiency, and ensuring real-time visibility. Explore how MES coordinates and optimizes operations, from order initiation to product completion.`,
    keyFeatures: [
      {
        title: "Shop floor control and monitoring",
        content: "Efficient control and monitoring of manufacturing activities on the shop floor.",
      },
      {
        title: "Real-time production tracking",
        content: "Track production progress in real-time for better visibility and decision-making.",
      },
      {
        title: "Quality management integration",
        content: "Integrate quality management into manufacturing processes for improved product quality.",
      },
      {
        title: "Resource allocation and scheduling",
        content: "Optimize resource allocation and scheduling for efficient manufacturing operations.",
      },
      {
        title: "Data analytics for performance improvement",
        content: "Utilize data analytics to identify areas for performance improvement in manufacturing.",
      },
    ],
    howItWorks: "Learn about the functionality of MES in coordinating and optimizing manufacturing operations, from order initiation to product completion.",
    benefits: {
      title: "The benefits of Smart Manufacturing Execution Systems (MES)",
      data: [
        "Increased production efficiency.",
        "Improved quality control.",
        "Enhanced resource utilization.",
        "Real-time data-driven decision-making.",
      ],
    },
    industries: "Ideal for automotive, aerospace, electronics manufacturing, and other industries seeking operational excellence.",
    stories: `Discover success stories of manufacturers who have implemented MES and achieved operational excellence.`,
    contactUs: `Connect with our experts for inquiries and consultations related to MES implementation.`,
    technology: `Understand how MES seamlessly integrates with other manufacturing systems for seamless operations.`,
    support: `Access resources and support channels for users to understand and maximize the benefits of MES.`,
    industry: `Learn how MES aligns with industry standards and compliance requirements for manufacturing.`,
    events: "Stay informed about upcoming features and innovations in MES technology.",
    blog: `Read articles, case studies, and expert opinions in our smart manufacturing blog and knowledge hub.`,
    careers: `Explore opportunities to contribute to the development of MES technology.`,
  };
  
  const content = "Embark on a retail revolution with us! Whether you're immersed in retail technology, e-commerce innovation, customer experience enhancement, or any facet of the retail industry, we offer tailored solutions. Our expertise spans projects of various scales, ensuring our retail solutions align seamlessly with your goals, budget, and scope."
    return (
    <>
 <Head>
    <title>E-commerce Platforms with Personalization Features | Enhance Shopping Experience | Techbrain Networks</title>
    <meta name="description" content="Enhance your online shopping experience with Techbrain Networks E-commerce Platforms featuring advanced personalization to tailor offerings to each customer." />
    <meta name="keywords" content="e-commerce, personalization, online shopping, Techbrain Networks" />
    <meta property="og:title" content="E-commerce Platforms with Personalization Features | Enhance Shopping Experience | Techbrain Networks" />
    <meta property="og:description" content="Techbrain Networks E-commerce Platforms with personalization features provide a tailored shopping experience, improving customer satisfaction and engagement." />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://www.techbrainnetworks.com/industries/retail/products/e-commerce-platforms" />
    <meta property="og:image" content="https://www.techbrainnetworks.com/logo-tbn.jpg" />
    <meta property="og:image:alt" content="E-commerce Platforms with Personalization Features" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="E-commerce Platforms with Personalization Features | Enhance Shopping Experience" />
    <meta name="twitter:description" content="Improve customer satisfaction with Techbrain Networks E-commerce Platforms, featuring advanced personalization for a tailored shopping experience." />
     <meta name="twitter:image" content="https://www.techbrainnetworks.com/logo-tbn.jpgg" />
    <link rel="canonical" href="https://www.techbrainnetworks.com/industries/retail/products/e-commerce-platforms" />
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "E-commerce Platforms with Personalization Features",
        "image": "https://www.techbrainnetworks.com/logo-tbn.jpg",
        "description": "Enhance your online shopping experience with Techbrain Networks E-commerce Platforms featuring advanced personalization to tailor offerings to each customer.",
        "brand": "Techbrain Networks",
        "offers": {
            "@type": "Offer",
            "url": "https://www.techbrainnetworks.com/industries/retail/products/e-commerce-platforms",
            "priceCurrency": "USD",
            "price": "Contact for pricing"
        }
    })}} />
 <link rel="icon" href="/favicon.png" />

</Head>
<StickyWhatsappIndustries link={"https://api.whatsapp.com/send?phone=918754906714"}  color={"#F94892"} />
      <AppbarIndustry title={"Retail"} homeLink={'/industries/retail'} link={'/industries/retail/products'} />
      <HeroSection img={"/industries/retail/e-commerce-platforms.avif"}>E-commerce Platforms with Personalization Features</HeroSection>
      <Box
        sx={{
          px: [0, "1.2rem", "3.8rem", "3rem"],
          pb: [1, 1, 2, 2, 4],
          bgcolor: "#080204",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        {/* intro */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080204",
            px: ["1rem"],
            py: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",

            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#F94892"}>Introduction</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.intro}
          </Typography>
        </Box>
        {/* Key Features Unleashed */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080204",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            gap: ["1.5rem", ".5rem", "1.5rem", "1.5rem", "1rem"],
          }}
        >
          <TitleIndustry color={"#F94892"}>Key Features Unleashed</TitleIndustry>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: ["column", "row"],
              flexWrap: "wrap",
              justifyContent: [null, "space-between", "flex-start"],
              gap: ["2rem", "1rem", "2rem", "2rem", "2rem"],
            }}
          >
            {data.keyFeatures.map((i, k) => (
              <Box
                sx={{
                  display: "flex",
                  width: ["95%", "45%", "30%"],
                  flexDirection: "column",
                  gap: ["0.5rem", "0.5rem", "0.5rem", "0.5rem", "1rem"],
                }}
              >
                <Typography
                  sx={{
                    fontSize: [
                      "1.3rem",
                      "1.2rem",
                      "1.2rem",
                      "1.4rem",
                      "1.5rem",
                    ],
                    fontWeight: "bold",
                    color: "#F94892",
                  }}
                >
                  {i.title}
                </Typography>
                <Typography
                  sx={{
                    fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                    color: "#fff",
                  }}
                >
                  {i.content}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
        {/* how it works */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080204",
            px: ["1rem"],
            py: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#F94892"}>How It Works?</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.howItWorks}
          </Typography>
        </Box>
        {/* benefits */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent={"space-between"}
          alignItems={"center"}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080204",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            gap: ["1.5rem", "1.5rem", ".5rem"],
          }}
        >
          <Stack
            direction={"column"}
            sx={{
              width: ["100%", "48%"],
            }}
          >
            <TitleIndustry color={"#F94892"}>Benefits</TitleIndustry>
            <Typography
              sx={{
                fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                color: "#fff",
              }}
            >
              {data.benefits.title}:
            </Typography>

            <Stack
              direction={"column"}
              sx={{
                gap: [1, 1, 2],
                mt: [3, 3, 4],
              }}
            >
              {data.benefits.data.map((i, k) => (
                <Typography
                  sx={{
                    fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                    color: "#fff",
                  }}
                >
                  {"•  "}
                  {i}
                </Typography>
              ))}
            </Stack>
          </Stack>

          <Box
            sx={{
              width: ["100%", "50%", "45%"],
              height: ["20rem", "20rem", "20rem", "25rem", "30rem"],
              backgroundImage: `url(${data.image})`,
              backgroundposition: "center",
              backgroundSize: "cover",
              backgroundrepeat: "no-repeat",
              borderRadius: "16px",
            }}
          />
        </Stack>
        {/* Industries */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080204",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#F94892"}>Industries</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.industries}
          </Typography>
        </Box>

       
        {/* Future Developments and Innovations*/}
 
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080204",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#F94892"}>Future Developments and Innovations</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            Stay informed about upcoming features and innovations in cybersecurity threat intelligence technology.
          </Typography>
        </Box>

        {/* Technology Integration */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080204",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#F94892"}>Technology Integration</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.technology}
          </Typography>
        </Box>

        {/* User Training and Support */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080204",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#F94892"}>User Training and Support</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.support}
          </Typography>
        </Box>

        {/*  Industry Standards and Compliance */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#080204",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#F94892"}> Industry Standards and Compliance</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.industry}
          </Typography>
        </Box>

        <Box
          sx={{
            width: "100%",
          
            display: "flex",
            gap: "1rem",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: ["2rem", "3rem", "3rem", "4rem"],
                fontWeight: "bold",
                color: "#F94892",
                textAlign: "center",
              }}
            >
              Contact
            </Typography>
          </Box>
      <Box
            sx={{
              width: [ "100%"],
              display: "flex",
              justifyContent: "center",
              padding:'1rem'
            }}
          >
            <HeroEnquiryFormIndustry color={"#F94892"} products={products} content={content}/>
          </Box>
        </Box>
      </Box>
      <FooterIndustry ourProducts={ourProducts} color={"#F94892"} bg={"#080204"} />
    </>
  );
}

export default AdvancedCybersecurity;
